import { type ImageProps } from '../_sections/sections'

export default function Image({
	image,
	className,
}: {
	image: ImageProps
	className?: string
}) {
	if (!image) return null

	return (
		<img
			className={className ? className : ''}
			alt={image?.alternativeText ?? ''}
			src={image.url ?? 'https://via.placeholder.com/320x320'}
		/>
	)
}
